import { createStyles } from '@material-ui/core/styles';
import { darken } from '@material-ui/core/styles';


const useStyles = (theme) => createStyles({
  '.App': {
    textAlign: 'center',
    backgroundColor: "#E6E6FA",
  },
  '.App-header': {
    backgroundColor: theme.palette.grey[900],
    height: '150px',
    padding: '20px',
    color: 'white',
  },
  '.App-intro': {
    fontSize: 'large',
  },
  success: {
    backgroundColor: `${theme.palette.success.light} !important`,
    color: `${theme.palette.success.contrastText} !important`,
  },
  error: {
    backgroundColor: `${theme.palette.error.light} !important`,
    color: `${theme.palette.error.contrastText} !important`,
  },
  warning: {
    backgroundColor: `${theme.palette.warning.light} !important`,
    color: `${theme.palette.warning.contrastText} !important`
  },
  info: {
    backgroundColor: `${theme.palette.info.light} !important`,
    color: `${theme.palette.info.contrastText} !important`
  },
  '@global': {
    '*::-webkit-scrollbar': {
      height: theme.spacing(1),
      width: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        height: theme.spacing(0.5),
        width: theme.spacing(0.5),
      },
    },
    '*::-webkit-scrollbar-track': {
      backgroundColor: theme.palette.background.default,
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: darken(theme.palette.secondary.light, 0.1),
      borderRadius: '50px',
    },

    /*
    * react-split-pane resizer css
    *
    * color should not be static and reflect the theme
    * now is set to the default primary main color
    *
    */
    '.Resizer': {
      background: theme.palette.primary.main,
      opacity: 0.2,
      zIndex: 1,
      mozBoxSizing: 'border-box',
      webkitBoxSizing: 'border-box',
      mozBackgroundClip: 'padding',
      webkitBackgroundClip: 'padding',
      backgroundClip: 'padding-box',
    },
    '.Resizer:hover': {
      webkitTransition: 'all 2s ease',
      transition: 'all 2s ease',
    },
    '.Resizer.horizontal': {
      height: '11px',
      margin: '-5px 0',
      borderTop: '5px solid transparent',
      borderBottom: '5px solid transparent',
      cursor: 'ns-resize',
      width: '100%',
    },
    '.Resizer.horizontal:hover': {
      borderTop: `5px solid ${theme.palette.action.active}`,
      borderBottom: `5px solid ${theme.palette.action.active}`,
    },
    '.Resizer.vertical': {
      opacity: 1,
      width: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      marginTop: 'calc(50vh - 45px)',
      marginBottom: 'calc(50vh - 45px)',
      borderRadius: '6px',
      cursor: 'ew-resize',
    },
    '.Resizer.vertical:hover': {
      //borderLeft: `5px solid ${theme.palette.action.active}`,
      //borderRight: `5px solid ${theme.palette.action.active}`,
    },
    '.Resizer.disabled': {
      cursor: 'default',
    },
    '.Resizer.disabled:hover': {
      borderColor: 'transparent',
    },
  }
});

export default useStyles;
